<template>
  <div>
    <div class="row">
      <div class="col-md-12 mb-2">
        <div class="d-flex flex-row align-items-start justify-content-center">
          <div>
            <div class="small">OVERVIEW</div>
            <div class="h3">Dashboard</div>
          </div>
          <div class="ml-auto">
            <b-button variant="success" @click="trainModel()">Train Model and Predict</b-button>
          </div>
        </div>
      </div>
      <div v-if="showAI" class="col-md-12 my-2">
        <div class="card">
          <div class="card-header">
            <div class="d-flex flex-row align-items-start justify-content-center">
              <h5 class="mb-0">Total Quantity Prediction - Intellobuy</h5>
              <div class="ml-auto">
                <span @click="closeML()">
                  <i class="fas fa-times"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 border-right">
                <h4 class="text-center">
                  <strong>
                    {{ aiData.currentMonth }} -
                    {{ aiData.currentYear }}
                  </strong>
                </h4>
                <div class="row mx-0 mt-4">
                  <div class="col-4 bg-info">
                    <div class="p-2 bg-info text-center text-white">AI Predicted</div>
                    <p class="mb-0 mt-1 font-weight-bold text-center">{{ aiData.predictedVal }}</p>
                  </div>
                  <div class="col-4 bg-success">
                    <div class="p-2 bg-success text-center text-white">Data Till Now</div>
                    <p class="mb-0 mt-1 font-weight-bold text-center">{{ aiData.currentVal }}</p>
                  </div>
                  <div class="col-4 bg-warning">
                    <div class="p-2 bg-warning text-center text-white">Deficit</div>
                    <p class="mb-0 mt-1 font-weight-bold text-center">{{ aiData.diffVal }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-2 border-right position-relative">
                <VueSvgGauge
                  :start-angle="-110"
                  :end-angle="110"
                  :value="aiData.metPercentage"
                  :separator-step="20"
                  :min="0"
                  :max="100"
                  :innerRadius="60"
                  :gauge-color="[
                    { offset: 0, color: '#347AB0' },
                    { offset: 100, color: '#8CDFAD' }
                  ]"
                  :scale-interval="0.1"
                ></VueSvgGauge>
                <div
                  class="text-center font-weight-bold position-absolute"
                  style="left:35%; top:60%;"
                >Met : {{ aiData.metPercentage }}%</div>
              </div>
              <div class="col-md-4 position-relative">
                <div class="text-center">
                  <img :src="require('../assets/Multivariate_Gaussian.png')" class="img-fluid" />
                </div>
                <div class="position-absolute" style="top: 25%; left: 40%; text-align: center;">
                  <h5>ML Technique used</h5>
                  <p>Gaussian Distribution Linear Regression</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-primary mb-3">
          <div class="card-header">
            <div class="d-flex flex-row align-items-start justify-content-center">
              <h5 class="mb-0">Styles</h5>
              <div class="ml-auto">
                <div>
                  <b-dropdown
                    size
                    variant="link"
                    toggle-class="text-decoration-none text-white p-0"
                    caret
                  >
                    <template #button-content>
                      <span class>Last 30 Days</span>
                    </template>
                    <b-dropdown-item>Last 3 Months</b-dropdown-item>
                    <b-dropdown-item>Last 6 Months</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h1>{{ allCounts.uniqueStyles }}</h1>
              </div>
              <div class="col-6 text-right">
                <i class="fas fa-tshirt fa-4x ico-opacity"></i>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <div class="row">
              <div class="col-6 text-left text-muted">
                <h4>{{ allCounts.totalStyles }}</h4>
              </div>
              <div class="col-6">
                <a
                  @click="fetchDetailedData('style')"
                  type="button"
                  class="btn btn-primary"
                >Get Details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-info mb-3">
          <div class="card-header">
            <div class="d-flex flex-row align-items-start justify-content-center">
              <h5 class="mb-0">Customers</h5>
              <div class="ml-auto">
                <div>
                  <b-dropdown
                    size
                    variant="link"
                    toggle-class="text-decoration-none text-white p-0"
                    caret
                  >
                    <template #button-content>
                      <span class>Last 30 Days</span>
                    </template>
                    <b-dropdown-item>Last 3 Months</b-dropdown-item>
                    <b-dropdown-item>Last 6 Months</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h1>{{ allCounts.customer }}</h1>
              </div>
              <div class="col-6 text-right">
                <i class="fas fa-sort-amount-up-alt fa-4x ico-opacity"></i>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <a
              @click="fetchDetailedData('customer')"
              type="button"
              class="btn btn-primary"
            >Get Details</a>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-success mb-3">
          <div class="card-header">
            <div class="d-flex flex-row align-items-start justify-content-center">
              <h5 class="mb-0">Products</h5>
              <div class="ml-auto">
                <div>
                  <b-dropdown
                    size
                    variant="link"
                    toggle-class="text-decoration-none text-white p-0"
                    caret
                  >
                    <template #button-content>
                      <span class>Last 30 Days</span>
                    </template>
                    <b-dropdown-item>Last 3 Months</b-dropdown-item>
                    <b-dropdown-item>Last 6 Months</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h1>{{ allCounts.product }}</h1>
              </div>
              <div class="col-6 text-right">
                <i class="fab fa-accusoft fa-4x ico-opacity"></i>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <a
              @click="fetchDetailedData('product')"
              type="button"
              class="btn btn-primary"
            >Get Details</a>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white cyan-300 mb-3">
          <div class="card-header">
            <div class="d-flex flex-row align-items-start justify-content-center">
              <h5 class="mb-0">Color</h5>
              <div class="ml-auto">
                <div>
                  <b-dropdown
                    size
                    variant="link"
                    toggle-class="text-decoration-none text-white p-0"
                    caret
                  >
                    <template #button-content>
                      <span class>Last 30 Days</span>
                    </template>
                    <b-dropdown-item>Last 3 Months</b-dropdown-item>
                    <b-dropdown-item>Last 6 Months</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h1>{{ allCounts.color }}</h1>
              </div>
              <div class="col-6 text-right">
                <i class="fas fa-book-open fa-4x ico-opacity"></i>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <a @click="fetchDetailedData('color')" type="button" class="btn btn-primary">Get Details</a>
          </div>
        </div>
      </div>
      <div class="w-100 my-2">&nbsp;</div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">Detailed Data - {{ selectedParam }}</h5>
          </div>

          <div class="card-body">
            <div class="section-h2">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Sl</th>
                    <th>Oraganisation</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="item._id">
                    <td>{{ ++index }}</td>
                    <td v-if="selectedParam == 'style'">{{ item.organisation }}</td>
                    <td
                      v-else-if="selectedParam == 'color'"
                    >{{ item.po }} , {{ item.color }} , {{ item.user }}</td>
                    <td>{{ item.count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <div class="row">
          <div class="col-6" v-if="loadedPie">
            <div class="card">
              <div
                class="card-header bg-info mx-2 shadow text-center text-white"
                style="margin-top: -1rem;"
              >
                <div class="w-75">
                  <pie-chart :data="chartDataPie" :options="chartOptionsPie"></pie-chart>
                </div>
              </div>
              <div class="card-body text-right pb-2">
                <h5 class="mb-1">Distribution</h5>
                <p class="mb-0">Product Wise Performance</p>
                <hr class="my-2" />
                <i class="far fa-clock mr-1"></i>
                <small>Updated 2 days ago</small>
              </div>
            </div>
          </div>

          <div class="col-6" v-if="loaded">
            <div class="card">
              <div
                class="card-header bg-info mx-2 shadow text-center text-white"
                style="margin-top: -1rem;"
              >
                <div class="w-75">
                  <bar-chart :chart-data="chartData" :options="chartOptions" />
                </div>
              </div>
              <div class="card-body text-right pb-2">
                <h5 class="mb-1">Data Accumalation</h5>
                <p class="mb-0">Distribution across last 30 days</p>
                <hr class="my-2" />
                <i class="far fa-clock mr-1"></i>
                <small>Updated 2 days ago</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PieChart from "../components/PieChart";
import BarChart from "../components/BarChart.js";
export default {
  name: "Dashboard",
  components: {
    PieChart,
    BarChart
  },
  data: () => ({
    items: [],
    showAI: false,
    aiData: {},
    fullPage: false,
    selectedParam: "",
    styleMeta: {},
    allCounts: {},
    chartOptions: {
      responsive: true,
      maintainAspectRatio: true
    },
    chartData: {},
    loaded: false,
    loadedPie: false,
    chartOptionsPie: {
      hoverBorderWidth: 20
    },
    chartDataPie: {
      hoverBackgroundColor: "red",
      hoverBorderWidth: 10,
      // labels: ["Green", "Red", "Blue"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#00D8FF", "#41B883", "#D9B1D8", "#D9CBB1"]
          //  data: [1, 10, 5]
        }
      ]
    }
  }),
  methods: {
    async fetchDetailedData(param) {
      const { data } = await axios.get(process.env.VUE_APP_STYLES_API_URL, {
        params: { time: "", param: param }
      });

      this.items = data.data;
      this.styleMeta = data.meta;
      this.populatePieChart(this.styleMeta);
      this.populateChart(this.styleMeta);
      this.selectedParam = param;
    },
    async trainModel() {
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
        loader: "bars"
      });
      const { data } = await axios.get(process.env.VUE_APP_MLTRAIN_API_URL);
      this.showAI = true;
      this.aiData = data;
      loader.hide();
    },
    onCancel() {
      console.log("User cancelled the loader.");
      this.showAI = false;
    },
    async closeML() {
      this.showAI = false;
    },
    async getAllCounts() {
      const { data } = await axios.get(process.env.VUE_APP_COUNTS_API_URL);
      this.allCounts = data;
    },
    async populatePieChart(resultSet) {
      console.log(resultSet);
      this.loadedPie = false;
      var dataSet = [];
      this.chartDataPie.labels = [
        "IntelloBuy",
        "IntelloCut",
        "FRP-Web",
        "GSD-V5",
        "VISION-PLM"
      ];
      // this.chartDataPie.datasets.data = [resultSet.Comments, resultSet.Votes];
      dataSet.push({
        label: "Data One",
        backgroundColor: [
          "#00D8FF",
          "#41B883",
          "#D9B1D8",
          "#D9CBB1",
          "#ffffb3"
        ],
        data: [
          resultSet.buyCount,
          resultSet.cutCount,
          resultSet.frpv5Count,
          resultSet.gsdv5Count,
          resultSet.plmCount
        ]
      });
      this.chartDataPie.datasets = dataSet;
      this.loadedPie = true;
    },
    async populateChart(resultSet) {
      var dataSet = [];
      var label = [];
      for (var i = 1; i <= 7; i++) {
        label.push(
          this.$moment()
            .subtract(i, "days")
            .format("DD MM YYYY")
        );
      }

      // var label = ["day7", "day6", "day5", "day4", "day3", "day2", "day1"];
      var data = [
        resultSet.day1,
        resultSet.day2,
        resultSet.day3,
        resultSet.day4,
        resultSet.day5,
        resultSet.day6,
        resultSet.day7
      ];
      // for (var i = 0; i < resultSet.length; i++) {
      //   label.push(resultSet[i].prodName);
      //   data.push(resultSet[i].prodSuggestionCount);
      // }
      dataSet.push({
        label: "Count",
        backgroundColor: "#f87979",
        data: data
      });
      this.$set(this.chartData, "labels", label);
      this.$set(this.chartData, "datasets", dataSet);
      // this.chartData.labels = label;
      // this.chartData.datasets = dataSet;
      this.loaded = true;
    }
  },
  beforeMount() {
    this.getAllCounts();
  }
};
</script>
<style scoped>
.section-h2 {
  max-height: 250px;
  overflow: auto;
}
.ico-opacity {
  opacity: 0.5;
}
</style>
